module.exports = __webpack_public_path__ + "img/made-in-usa.20f48b45.png";